// Erin's waitlist (/pages/erin-waitlist). Posts to the Messina Stores app through the app proxy,
// which saves the person to Shopify and tags them in Marsello for each list they ticked.
(() => {
  const form = document.querySelector("[data-ew-form]");
  if (!form) return;
  const q = (s) => form.querySelector(s);
  const fields = q("[data-ew-fields]");
  const done = q("[data-ew-done]");
  const formError = q("[data-ew-form-error]");
  const button = q('button[type="submit"]');
  const lists = q("[data-ew-lists]");
  const controls = { lists, first_name: q('[name="first_name"]'), email: q('[name="email"]'), consent: q('[name="consent"]') };
  // An email can link straight to one list (?list=tours or ?list=pour-decisions) and arrive with it ticked.
  for (const want of new URLSearchParams(location.search).getAll("list")) {
    const box = form.querySelector(`input[name="lists"][value="${CSS.escape(want)}"]`);
    if (box) box.checked = true;
  }
  const ticked = () => [...form.querySelectorAll('input[name="lists"]:checked')].map((i) => i.value);

  function show(errors) {
    for (const [key, control] of Object.entries(controls)) {
      const msg = errors[key];
      const el = q(`[data-ew-error="${key}"]`);
      el.textContent = msg || "";
      el.hidden = !msg;
      const marked = key === "lists" ? [...form.querySelectorAll('input[name="lists"]')] : [control];
      for (const c of marked) msg ? c.setAttribute("aria-invalid", "true") : c.removeAttribute("aria-invalid");
      if (key === "lists") control.toggleAttribute("data-invalid", Boolean(msg));
    }
    const first = Object.keys(controls).find((k) => errors[k]);
    if (first) (first === "lists" ? q('input[name="lists"]') : controls[first]).focus();
  }

  // The same rules the server runs, so most slips are caught before anything is sent.
  function check() {
    const e = {};
    if (!ticked().length) e.lists = "Pick at least one.";
    if (!controls.first_name.value.trim()) e.first_name = "Add your first name.";
    const email = controls.email.value.trim();
    if (!email) e.email = "Add your email.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) e.email = "That email doesn't look right.";
    if (!controls.consent.checked) e.consent = "Tick this so we can email you.";
    return e;
  }

  // An error clears once its field is fixed, without waiting for the next submit.
  form.addEventListener("input", (ev) => {
    const key = ev.target.name;
    if (!(key in controls)) return;
    if (key === "lists" && !ticked().length) return;
    if (key === "consent" && !ev.target.checked) return;
    const el = q(`[data-ew-error="${key}"]`);
    if (!el || el.hidden) return;
    el.hidden = true;
    el.textContent = "";
    const marked = key === "lists" ? [...form.querySelectorAll('input[name="lists"]')] : [controls[key]];
    for (const c of marked) c.removeAttribute("aria-invalid");
    if (key === "lists") lists.removeAttribute("data-invalid");
  });

  form.addEventListener("submit", async (ev) => {
    ev.preventDefault();
    formError.hidden = true;
    const errors = check();
    show(errors);
    if (Object.keys(errors).length) return;
    button.disabled = true;
    try {
      const r = await fetch(`${form.dataset.endpoint}/waitlist`, {
        method: "POST",
        headers: { "content-type": "application/json", accept: "application/json" },
        body: JSON.stringify({
          first_name: controls.first_name.value.trim(),
          email: controls.email.value.trim(),
          lists: ticked(),
          consent: controls.consent.checked,
          company: q('[name="company"]').value,
        }),
      });
      const data = await r.json().catch(() => ({}));
      if (r.ok && data.ok) {
        fields.hidden = true;
        done.hidden = false;
        done.querySelector("h2").focus();
        return;
      }
      if (data.errors) return show(data.errors);
      formError.textContent = data.error || "Something went wrong on our end. Try again in a minute.";
      formError.hidden = false;
    } catch {
      formError.textContent = "We couldn't reach the list. Check your connection and try again.";
      formError.hidden = false;
    } finally {
      button.disabled = false;
    }
  });
})();
